import { createAction } from "@reduxjs/toolkit";
import type { BatchPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { BATCH_ORGANIZER_TYPE } from "@academy-context/shared/domain/types/enums/batch-organizer-type";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveProviderBatchParticipationPaymentList = createApiThunk<BatchPaymentVM[], void>(
  "providers/retrieveProviderBatchParticipationPaymentList",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listBatchPayments(BATCH_ORGANIZER_TYPE.PROVIDER);
  },
);

export const resetRetrieveProviderBatchParticipationPaymentList = createAction(
  "providers/resetRetrieveProviderBatchParticipationPaymentList",
);
